import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const attributes = Object.freeze({
  color:"",
  classes:"",
  size: "36"
});

export default function DiningTable({ attributes={
  color: "",
  classes: "",
  size: ""
}, clickHandler }) {
  const navigate = useNavigate();
  return (
    <div className={attributes.classes} onClick={clickHandler}>
      <svg
        xmlns="http://www.w3.org/2000/svg" 
        width={attributes.size}
        height={attributes.size}
        viewBox="0 0 38 38"
      >
        <g id="Table" transform="translate(-787 -219)">
          <circle id="Ellipse_218" data-name="Ellipse 218" cx="18" cy="18" r="18" transform="translate(787 219)" fill="#97f8ec"/>
          <g id="daining-table" transform="translate(781.5, 209) scale(1.35)">
            <path id="Path_12204" data-name="Path 12204" d="M43.3,22.462V25.8s-.047.137-.058.159a.432.432,0,0,1-.778-.065c-.094-1.568-.014-3.157-.04-4.735-.011-.141.169-.454.314-.454h4.321c.007-.115-.007-.231,0-.346.065-1.06.141-2.126.277-3.179a11.605,11.605,0,0,1,.169-1.15.432.432,0,0,1,.843.187c-.014.328-.123.714-.162,1.045a27.763,27.763,0,0,0-.083,6.937,14.669,14.669,0,0,1,.231,1.665.428.428,0,0,1-.8.054,6.456,6.456,0,0,1-.2-.98c-.123-.735-.166-1.445-.227-2.188a.667.667,0,0,0-.068-.288H43.3Z" transform="translate(-22.009 0)"/>
            <path id="Path_12205" data-name="Path 12205" d="M9.311,22.471l-.04.068c-.032.685-.1,1.377-.195,2.054a8.028,8.028,0,0,1-.256,1.333.424.424,0,0,1-.811-.18A26.494,26.494,0,0,0,8.2,17.516c-.047-.418-.173-.915-.187-1.323A.423.423,0,0,1,8.835,16a5.65,5.65,0,0,1,.133.8c.119.822.22,1.723.277,2.548.032.45.018.908.054,1.359h4.35a.552.552,0,0,1,.238.227L13.9,25.92a.434.434,0,0,1-.645.177c-.184-.123-.184-.292-.195-.49-.05-1.034.04-2.108,0-3.143H9.311Z" transform="translate(0 -0.009)"/>
            <path id="Path_12206" data-name="Path 12206" d="M22.793,18.331a28.508,28.508,0,0,1,4,.13c.523.061,1.982.256,2.292.674.479.645-.829.937-1.229,1.02a22.2,22.2,0,0,1-4.988.281c-.9-.025-3.651-.123-4.281-.714a.439.439,0,0,1,.043-.7c.717-.544,3.225-.667,4.166-.692Z" transform="translate(-6.667 -1.678)"/>
            <path id="Path_12207" data-name="Path 12207" d="M23.54,24.781a21.12,21.12,0,0,1-2.479-.169c-.407-.05-.858-.119-1.258-.195-.562-.108-1.2-.216-1.283-.9.155.072.306.148.468.205a17.5,17.5,0,0,0,5.308.508,15.693,15.693,0,0,0,4.393-.49c.18-.065.35-.166.533-.22a.949.949,0,0,1-.623.76,15.471,15.471,0,0,1-3.452.5,6.394,6.394,0,0,0-.948.029v3.9h1.607a.329.329,0,0,1,.054.656l-4.047-.011a.334.334,0,0,1-.029-.634l1.759-.04v-3.9Z" transform="translate(-6.722 -5.008)"/>
          </g>
        </g>
      </svg>
    </div>
  );
}
